import { Granularity as n } from "./period.types.js";
import { useMemo as c } from "react";
import { d as a } from "./dayjsExtension-DC5Mvhv4.mjs";
const h = (e) => {
  switch (e == null ? void 0 : e.substring(0, 2).toLowerCase()) {
    case "fr":
      a.locale("fr");
      break;
    case "en":
      a.locale("en");
      break;
    default:
      throw new Error(`unhandled locale: ${e}`);
  }
}, d = (e) => {
  const t = a(e.start).startOf("day");
  return a(e.end).endOf("day").diff(t, "day") + 1;
}, D = (e) => c(() => d(e), [e]), m = (e, t, r, s) => {
  const o = f(e);
  return {
    start: a(r.start).subtract(t ?? s, o).startOf("day"),
    end: a(r.end).subtract(t ?? s, o).endOf("day")
  };
}, w = ({ start: e, end: t }, r = "dd DD MMM YYYY") => `${e.format(r)} - ${t.format(r)}`, f = (e) => {
  switch (e) {
    case n.DAY:
      return "day";
    case n.WEEK:
      return "week";
    case n.MONTH:
      return "month";
    case n.QUARTER:
      return "quarter";
    case n.YEAR:
      return "year";
    default:
      return e;
  }
};
export {
  h as configureLocale,
  f as convertMetricGrowthPeriodUnitToDayjsUnit,
  d as getDayDifference,
  w as intervalToString,
  m as toInterval,
  D as useDayDifference
};
//# sourceMappingURL=utils.js.map
